export default "__VITE_ASSET__I4pyb$8g__"